import { render, staticRenderFns } from "./VueBootstrap.vue?vue&type=template&id=25ab63aa&scoped=true"
import script from "./VueBootstrap.vue?vue&type=script&lang=js"
export * from "./VueBootstrap.vue?vue&type=script&lang=js"
import style0 from "./VueBootstrap.vue?vue&type=style&index=0&id=25ab63aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab63aa",
  null
  
)

export default component.exports